<script setup>
const props = defineProps({
  tags: {
    type: Array,
    required: true,
  },
  setCursor: {
    type: Function,
    required: true,
  },
});

const { tags, setCursor } = props;

const { locale } = useI18n();
const route = useRoute();

const query = gql`
    query CustomPages {
      posts(first: 4, where: { language: ${locale.value
        .toString()
        .toUpperCase()}, tagSlugIn: [${tags.map(
        (tag) =>
          `"${tag?.node?.name
            .normalize("NFD")
            .replace(/\p{Diacritic}/gu, "")},"`
      )}] }) {
        edges {
          node {
            title
            slug
            date
            featuredImage {
              node {
                mediaItemUrl
                id
              }
            }
            blogConfig {
              perex
              content
            }
          }
        }
      }
    }
  `;

const { data } = await useAsyncQuery(query);
</script>

<template>
  <div v-if="data?.posts?.edges?.length > 1">
    <div
      v-if="tags && tags.length > 0"
      class="lg:flex justify-center px-6 lg:pb-36 pb-20"
      @mouseenter="
        setCursor(null, null, {
          'font-size': '14px',
          background: '#FFC800',
          width: '25px',
          height: '25px',
          'z-index': '-1',
        })
      "
    >
      <div class="max-w-7xl w-full">
        <div class="lg:flex justify-center">
          <div>
            <h2 class="w-full h1 pb-6 lg:pb-12 lg:pl-7">
              Související <br />
              příspěvky
            </h2>
            <div
              v-if="data"
              class="grid grid-cols-1 lg:grid-cols-3 lg:gap-4 gap-12"
            >
              <ArticleCard
                v-for="article in data?.posts?.edges
                  .filter((e) => e.node.slug !== route.params.id)
                  .map((p) => {
                    return {
                      id: p.node.id,
                      title: p.node.title,
                      content: p.node.blogConfig?.content,
                      date: p.node.date,
                      featuredImage: p.node.featuredImage?.node?.mediaItemUrl,
                      perex: p.node.blogConfig?.perex,
                      slug: p.node.slug,
                    };
                  })"
                :key="article.id"
                :article="article"
                :set-cursor="setCursor"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.related-card {
  max-width: 500px;
  @media screen and (max-width: 1024px) {
    max-width: 100%;
  }
}
</style>
